import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { ImportsModule } from '../../../../modules/imports/imports';
import { SkeletonComponent } from '../../../../modules/shared/components/skeleton/skeleton.component';
import { CustomPhoneNumberComponent } from '../../../../modules/shared/components/custom-phone-number/custom-phone-number.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-customer-admin',
  templateUrl: './add-customer-admin.component.html',
  imports : [
    ImportsModule,
    SkeletonComponent,
    CustomPhoneNumberComponent,
    CommonModule
  ]
})
export class AddCustomerAdminComponent implements OnInit {
  @Input() customerId!: string;
  @Input() customerName!: string;
  @Input() customerDetails!: any;
  @Input() operation: string = 'view';
  @Input() loading!: boolean;
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter<any>();

  emailPattern: any =  /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid : boolean = true;
  customPhoneForm = new FormGroup({
    country: new FormControl<{ name: string; dial_code: string; code: string; flag: string } | null>(null, Validators.required),
    phoneNumber: new FormControl<string>('', [Validators.required, this.validatePhoneNumber.bind(this)])
  });
  selectedCountry!: { name: string; dial_code: string; code: string; flag: string; };
  isPrimaryMobileNoValid : boolean = true;
  customerAdminForm!: FormGroup ;

  constructor(
    private httpSrv: HttpService,
    private utilsSrv: UtilsService,
    private envService : EnvService,
    private dataSrv: DataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private utilsService:UtilsService
    ) { }

  async ngOnInit() {  
    this.customerAdminForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      username: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern),  this.utilsService.restrictedEmailCharactersValidator]),
    });  
    this.selectedCountry = USER_MGMT_DEFAULT_CONFIG_CNST.INITIAL_COUNTRY_DATA;
    this.customPhoneForm.patchValue({
      country: this.selectedCountry,
      phoneNumber: '' 
    });
    if(this.operation === 'edit') {
      if(!this.customerDetails) {
        const customerId = this.activatedRoute.snapshot.queryParams['customerId'];
        const options = {
          uriParams: {
            customerId
          }
        }
        const customerAdminInfo = await this.dataSrv.getCustomerAdminInfoByCustomerId(options);
        this.customerDetails = customerAdminInfo?.['response']?.[0];
        if(this.customerDetails) {
          this.customerAdminForm.get('firstName')?.setValue(this.customerDetails['first_name']);
          this.customerAdminForm.get('lastName')?.setValue(this.customerDetails['last_name']);
          this.customerAdminForm.get('username')?.setValue(this.customerDetails['username']);
          this.customerAdminForm.get('email')?.setValue(this.customerDetails['email_id']);
          try {
            let phoneNumberDetails = JSON.parse(this.customerDetails['mobile_number']) ?? null;
            this.customPhoneForm.patchValue({
              country: phoneNumberDetails?.['country'],
              phoneNumber : phoneNumberDetails?.['phoneNumber'] 
            })
          }
          catch(e) {

          }
        }
      }
    }
  }

  navigateToCustomerList() {
    this.router.navigate(['usermgmt', 'customer']);
  }


  validatePhoneNumber(control: FormControl): { [key: string]: boolean } | null {
    const country = this.customPhoneForm?.get('country')?.value;
    return {}
    // return this.utilsService?.validateMobileNumber(control, country);
  }
  
  onCountryChange(event: any) {
    this.customPhoneForm.patchValue({
      country: event?.value,
      phoneNumber: ''
    });
  }

  navigateToEdit() {
    this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }

  onlyAlphabet(event: any) {
    const pattern = /[a-zA-Z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  allowOnlyNumbers(event: any) {
    const pattern = /[0-9+\- ]/;

    let inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilsSrv.isEmailValid(this.emailPattern, inputStr);
  }

  onlyLowerCaseAlphabet(event: any) {
    const pattern = /[a-z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  addOrEditCustomerAdmin() {
    if(!this.customerDetails) {
      this.addCustomerAdmin()
    }else {
      this.dataEmitter.emit(true);
    }
  }

  updateCustomerAdminDetails() {
    if (this.customerAdminForm.invalid) {
      return;
    }
    const postData: any = this.postDataCreationForAddUser(true);
    if(this.customerDetails['email_id'] != this.customerAdminForm.get('email')?.value || this.customerDetails['username'] != this.customerAdminForm.get('username')?.value)
    {
      this.openPopup(postData);
    }
    else{
      const userId = this.customerDetails['user_id'];
      //* Create post data for update user
      postData['addRoles'] = {};
      postData['updateRoles'] = {};
      postData['deleteRoles'] = [];
      
      this.loading = true;
      this.httpSrv.makePutApiCall('UPDATE_USER', postData, this.envService.baseUrl, { uriParams: { userId } }).subscribe({
        next: (res: any) => {          
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization admin updated successfully' })
          this.dataEmitter.emit(true);
          this.loading = false;

        },
        error: (err: any) => {          
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err['error']['message']})
          this.loading = false;

        }
      });
    }
  }

  addCustomerAdmin(){
    if (this.customerAdminForm.invalid) {
      return;
    }
    //* Create post data for add user
    const postdata = this.postDataCreationForAddUser();
    //* Api call for add user
    this.loading = true;
    this.httpSrv.makePostApiCall('ADD_USER', postdata, this.envService.baseUrl).subscribe({
      next: (res: any) => {
        if (res.result) {
          this.updateUser(res.response, postdata);
        } else {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL })
        }
        this.dataEmitter.emit(true);
      },
      complete: () => {},
      error: (err: any) => {
        let errorMessage = USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL;

        if (!isNullOrUndefined(err)) {
            const { error } = err;
            const mobileNo = postdata['metaInfo']['mobileNo'];
            if (error?.message) {
                errorMessage = this.handleKeycloakError(error.message, mobileNo);
            } else {
                errorMessage = this.parseErrorText(err);
            }
        }
        // Display the error message
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
        this.loading = false;
    }
    });
  }

   handleKeycloakError(errorMessage: string, mobileNo: string): string {
    const { KEYCLOAK_ERROR_MSGS } = USER_MGMT_CNST;

    if (errorMessage.startsWith(`${KEYCLOAK_ERROR_MSGS.incomingMobileNoError} '${mobileNo}'`)) {
        return KEYCLOAK_ERROR_MSGS.displayedmobileNoErrorMsg;
    }
    
    return errorMessage.includes('users_mobile_number_key') 
        ? "Mobile Number Already Exists" 
        : errorMessage;
}

// Helper function to parse error text
 parseErrorText(err: any): string {
    const errorText = err.split(USER_MGMT_CNST.CONFLICT_STRING)[1];

    if (errorText) {
        try {
            const parsedError = JSON.parse(errorText);
            return parsedError[0]?.errorMessage || USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL; // Fallback
        } catch (e) {
            console.error("Failed to parse error text:", e);
            return USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL; // Fallback
        }
    }
    
    return USER_MGMT_CNST.ERROR_MESSAGES.CUST_ADMIN_GENERAL; // Fallback
}


  //* post data creation for add user
  postDataCreationForAddUser(isEdit = false){
    const postdata: any = {
      metaInfo: {
        "firstName": this.customerAdminForm.value.firstName,
        "lastName": this.customerAdminForm.value.lastName,
        "email": this.customerAdminForm.value.email,
        "mobileNo": this.customPhoneForm?.value ? JSON.stringify(this.customPhoneForm?.value): null,
        "customerId": this.customerId,
        "customerName": this.customerName,
        "username": this.customerAdminForm.value.username,
        "status": this.customerDetails?.status
      }
    }

    return postdata;
  }


  updateUser(userId: any, addUserPostData : any) {
    let postData = {
      "metaInfo": null,
      "addRoles": USER_MGMT_CNST.EDIT_USER_ADD_ROLE,
      "updateRoles": {},
      "deleteRoles": [],
      // "userId": userId

    }
    this.httpSrv.makePutApiCall('UPDATE_USER', postData, this.envService.baseUrl, { uriParams: { userId } }).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Organization admin added successfully' })
      },
      error: (err: any) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err['error']['message'] })
      }
    });
  }

  onPaste(event: ClipboardEvent,key : string) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    let trimmedText = key == 'username'? pastedText?.replace(/[^a-z]/g, ''): pastedText?.replace(/[^a-zA-Z]/g, '');
    setTimeout(() => {
      trimmedText = trimmedText?.substring(0,25);
      this.customerAdminForm.patchValue({
        [key]: trimmedText
      });
    }, 1);
  }

  openPopup(postData:any): void {
    this.confirmationService.confirm({
      message: 'Previous admin will be deleted and a new admin will be created',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        const userId = this.customerDetails['user_id'];
        //* Create post data for update user
        postData['addRoles'] = {};
        postData['updateRoles'] = {};
        postData['deleteRoles'] = [];
        
        this.loading = true;
        this.httpSrv.makePutApiCall('UPDATE_USER', postData, this.envService.baseUrl, { uriParams: { userId } }).subscribe({
          next: (res: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully updated organization admin' })
            this.loading = false;
            this.dataEmitter.emit(true);
          },
          error: (err: any) => {     
            this.loading = false;     
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err['error']['message'] })
          }
        });
      },
      reject: () => {
      }
    });
  }

  checkLength(event: any) {
    let value = event.target.value;

    if (value.length > 0) {
      this.isPrimaryMobileNoValid = !this.customPhoneForm.invalid;
    } else {
      this.isPrimaryMobileNoValid = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customerDetails'] && !changes['customerDetails'].isFirstChange()) {
      // Trigger an event when customerDetails changes
      if(this.customerDetails) {
        this.customerAdminForm.get('firstName')?.setValue(this.customerDetails['first_name']);
        this.customerAdminForm.get('lastName')?.setValue(this.customerDetails['last_name']);
        this.customerAdminForm.get('username')?.setValue(this.customerDetails['username']);
        this.customerAdminForm.get('email')?.setValue(this.customerDetails['email_id']);
        try {   
          let phoneNumberDetails = JSON.parse(this.customerDetails['mobile_number']) ?? null;
          this.customPhoneForm.patchValue({
            country: phoneNumberDetails?.['country'],
            phoneNumber : phoneNumberDetails?.['phoneNumber'] 
          })
        } catch(e) {
          
        }
      }
    }
  }
}
